// import React, { createContext, useState, useContext } from "react";
import React, { createContext, useState, useContext, useEffect } from "react";

const IntervalContext = createContext();

export const IntervalProvider = ({ children }) => {
  const [interval, setInterval] = useState("weekly"); // 기본값
  useEffect(() => {
    console.log("🔄 [Global IntervalContext] interval updated:", interval);
  }, [interval]);

  return (
    <IntervalContext.Provider value={{ interval, setInterval }}>
      {children}
    </IntervalContext.Provider>
  );
};

export const useInterval = () => useContext(IntervalContext);